import "./index.css";
import { Analytics } from "@vercel/analytics/react";
import photobombIcon from "./icon.png";
import { HeroHYE } from "./components/HeroHYE";
import { PromptsShowcaseSection } from "./components/PromptsShowcaseSection";
import { PromptTicker } from "./components/PromptTicker";
import { FooterSocialOrbs } from "./components/FooterSocialOrbs";
import { DiscordJoinToast } from "./components/DiscordJoinToast";

const DISCORD = "https://discord.gg/MzqENrF7r8";

export function App() {
  return (
    <div className="min-w-0 overflow-x-clip text-white">
      <div className="relative z-20 bg-[#0B1117]">
        <PromptTicker />
      </div>
      <main className="relative z-10">
        <HeroHYE />
        <PromptsShowcaseSection />
      </main>

      <footer className="landing-sans-copy border-t border-white/10 bg-[#0B1117] pb-[env(safe-area-inset-bottom,0px)] text-white">
        <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-12">
          <div className="grid grid-cols-1 items-center gap-6 sm:gap-5 lg:grid-cols-[auto_1fr_auto] lg:gap-8">
            <a
              href="/"
              className="justify-self-center flex items-center gap-3 text-3xl font-black tracking-tight text-white lg:justify-self-start"
            >
              <img
                src={photobombIcon}
                alt=""
                width={40}
                height={40}
                className="h-9 w-9 shrink-0 rounded-[4px] shadow-[0_4px_14px_rgba(0,0,0,0.35)] sm:h-10 sm:w-10"
                decoding="async"
              />
              Photobomb
            </a>
            <nav
              className="justify-self-center flex max-w-prose flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:gap-x-6"
              aria-label="Footer"
            >
              <a
                className="font-semibold text-white underline decoration-white underline-offset-[0.35em] transition hover:text-white/85"
                href="#get-started"
              >
                About
              </a>
              <a
                className="font-semibold text-white underline decoration-white underline-offset-[0.35em] transition hover:text-white/85"
                href="#prompts"
              >
                Prompts
              </a>
              <a
                className="font-semibold text-white underline decoration-white underline-offset-[0.35em] transition hover:text-white/85"
                href="/support"
              >
                Contact us
              </a>
              <a
                className="font-semibold text-white underline decoration-white underline-offset-[0.35em] transition hover:text-white/85"
                href={DISCORD}
                target="_blank"
                rel="noopener noreferrer"
              >
                Discord
              </a>
            </nav>
            <FooterSocialOrbs className="justify-self-center lg:justify-self-end" />
          </div>

          <div className="mt-8 border-t border-white/10 pt-6 sm:mt-9 sm:pt-7">
            <div className="flex flex-col items-center gap-3 text-sm text-white/70">
              <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 sm:gap-x-5">
                <a
                  className="underline decoration-white/40 underline-offset-[0.25em] transition hover:text-white"
                  href="/terms"
                >
                  Terms of Service
                </a>
                <span className="hidden text-white/25 sm:inline" aria-hidden>
                  ·
                </span>
                <a
                  className="underline decoration-white/40 underline-offset-[0.25em] transition hover:text-white"
                  href="/privacy"
                >
                  Privacy Policy
                </a>
              </div>
              <p className="max-w-md text-center leading-snug">
                Made with love for players everywhere{" "}
                <span aria-hidden className="text-white/90">
                  {'\u2764\uFE0F'}
                </span>
              </p>
              <p className="text-xs text-white/45">© 2026 Photobomb Game</p>
            </div>
          </div>
        </div>
      </footer>
      <DiscordJoinToast href={DISCORD} />
      <Analytics />
    </div>
  );
}

export default App;
